import moment from 'moment-timezone';
import angular from 'angular';

angular.module("companies")

    .controller("CompaniesEditCtrl", ['$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', 'modalService','$filter', function ($rootScope, $scope, $http, $stateParams, Restangular, $state, modalService, $filter) {

        $scope.noImage = "/assets/img/no-image.png";

        $scope.tinymceOptions = {
            resize: true,
            forced_root_block: false,
            contextmenu: false,
            branding: false,
            relative_urls: false,
            convert_urls: false,
            remove_script_host: false,
            height: 60,
            body_class: 'custom_tinymce_content',
            //valid_classes: 'razor_expression',
            language: 'es',
            paste_as_text: true,
            plugins: 'paste autoresize textcolor image lists advlist table noneditable code link',
            toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent link | table | image | code",
            menubar: false,
            statusbar: false,
            setup: function (editor) {

            }
        };

        $scope.timezones = moment.tz.names();

        $scope.configureLanguages = function () {
            if ($scope.company != null && $scope.languages != null) {
                angular.forEach($scope.company.FK_companies_languages_companies, function (companyLanguage) {
                    var languages = $filter('filter')($scope.languages, { id: companyLanguage.language_id }, 1);
                    languages[0].use_for_interface = companyLanguage.use_for_interface;
                    languages[0].use_for_translation = companyLanguage.use_for_translation;
                    languages[0].use_for_events = companyLanguage.use_for_events;
                });
            }
        };

        //cargando lenguajes
        Restangular.all('Languages').getList().then(function (results) {
            $scope.languages = results;
            $scope.configureLanguages();
        }, function (response) {
            $scope.errorMessage = response.message;
        });


        //Opciones de menú
        /*
         * De momento lo dejamos en un input sencillo
         * 
            $scope.menu_options = [

                {
                    name: $filter('translate')('companies.menu_classic'),
                    code: "FRONTEND",
                },
                {
                    name: $filter('translate')('companies.menu_new'),
                    code: "FRONTEND_NEW",
                }
            ]
        */
        $rootScope.title = $filter('translate')('companies.title');
        if (angular.isUndefined($stateParams.id) || $stateParams.id == ""   ) {
            
            $rootScope.breadcrumb = [
            { title: $filter('translate')('companies.list'), url: "companies.list" },
            { title: $filter('translate')('companies.add') }
            ];
            $scope.company = {
                name: '',
                created_at: new Date()
            };

            // $scope.company.program_mail_list_array = [];
            $scope.company.article_12 = true;
            $scope.selectPrecededDefault = [{ id: "article12", name: "article 12" }];
            $scope.company.default_order_article = "article12";

        }
        else {
            $rootScope.breadcrumb = [
            { title: $filter('translate')('companies.list'), url: "companies.list" },
            { title: $filter('translate')('companies.edit') }
            ];
            Restangular.one('Companies', $stateParams.id).get().then(function (results) {
                $scope.company = results;
                $scope.company.configurations = $scope.company.configurations.filter(m => m.code != 'PROGRAM_EMAIL_LIST');
                $scope.configurations = $scope.company.configurations;

                // Convertimos el listado en un array para que funcione con chips
                /*
                   A petición de Rofolfo, saco de aquí la lista de correos por defecto de la empresa
                   if ($scope.company.configurations.filter(m => m.code == 'PROGRAM_EMAIL_LIST').length > 0) {
                    let programMailList = $scope.company.configurations.filter(m => m.code == 'PROGRAM_EMAIL_LIST')[0].value;
                    if (programMailList && programMailList.length > 0) $scope.company.program_mail_list_array = $scope.company.configurations.filter(m => m.code == 'PROGRAM_EMAIL_LIST')[0].value.split(',');
                }
                */


                $scope.configureLanguages();
                $scope.loadComboPreceded();
            }, function (response) {
                $scope.errorMessage = response.message;
            });
        }

        $scope.addFile = function (flowFile) {

            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                var uri = event.target.result;
                $scope.$apply(function () {
                    $scope.company.logo = uri;
                });
            };
            fileReader.readAsDataURL(flowFile.file);

        };


        $scope.saveCompany = function () {



            // Sacamos del array los correos para guardarlos en la configuración.
            /*
               A petición de Rofolfo, saco de aquí la lista de correos por defecto de la empresa

                        if (typeof ($scope.company.configurations) !== "undefined" && $scope.company.configurations.filter(m => m.code == 'PROGRAM_EMAIL_LIST').length > 0 && $scope.company.program_mail_list_array) {
               

                        //Validamos que los emails sean correctos
                        let invalidMails = $scope.company.program_mail_list_array.filter(m => !validateEmail(m))
                        if (invalidMails.length > 0) {

                            let titleString = $filter('translate')('general.error');
                            let messageString = $filter('translate')('general.invalid_emails_message') + ": " + invalidMails.join(', ');

                            return modalService.message({
                                title: titleString,
                                message: messageString,
                                onAccept: function () { }
                            });

                        }

                    $scope.company.configurations.filter(m => m.code == 'PROGRAM_EMAIL_LIST')[0].value = $scope.company.program_mail_list_array.join(',');
            }
            */

            //generamos datos de lenguajes
            var finalCompanyLanguages = [];

            angular.forEach($scope.languages, function (language) {

                var companyLanguages = $filter('filter')($scope.company.FK_companies_languages_companies, { language_id: language.id }, 1);

                var companyLanguage: any = {};
                if (typeof(companyLanguages) !== "undefined" && companyLanguages.length > 0) companyLanguage = companyLanguages[0];
                companyLanguage.company_id = $scope.company.id;
                companyLanguage.language_id = language.id;
                companyLanguage.use_for_interface = language.use_for_interface ? language.use_for_interface : false;
                companyLanguage.use_for_translation = language.use_for_translation ? language.use_for_translation : false;
                companyLanguage.use_for_events = language.use_for_events ? language.use_for_events : false;
                finalCompanyLanguages.push(companyLanguage);

            });

            $scope.company.FK_companies_languages_companies = finalCompanyLanguages;

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "")
                Restangular.all('Companies').post($scope.company).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('companies.create_success'));
                        $state.go("companies.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            else {
                $scope.company.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('companies.edit_success'));
                        $state.go("companies.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        };

        /**
        let validateEmail = function (valor) {
            let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailPattern.test(valor)) {
                return true;
            } else {
                return false;
            }
        };
         */


        $scope.loadComboPreceded = function () {
            $scope.company.article_10;
            $scope.company.article_12;
            if ($scope.company.article_10 && $scope.company.article_12) {
                $scope.selectPrecededDefault = [{ id: "article12", name: "article 12" }, { id: "article10", name: "article 10" }];
            }
            if ($scope.company.article_10 && !$scope.company.article_12) {
                $scope.selectPrecededDefault = [{ id: "article10", name: "article 10" }];
            }
            if (!$scope.company.article_10 && $scope.company.article_12) {
                $scope.selectPrecededDefault = [{ id: "article12", name: "article 12" }];
            }
            if (!$scope.company.article_10 && !$scope.company.article_12) {
                $scope.selectPrecededDefault = [{}];
            }
        }

        $scope.deleteCompany = function () {

            modalService.confirm({
                title: $filter('translate')('companies.delete_button'),
                message: $filter('translate')('companies.delete_messafe')+" " + $scope.company.name + "?",
                onAccept: function () {
                    Restangular.one('Companies', $stateParams.id).remove().then(function () {
                        toastr.success($filter('translate')('companies.delete_success'));
                        $state.go("companies.list");
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

    }])

;